import { connect } from 'react-redux';
import { getVillageId, getCountrysideBuilderLandingPromoData } from '../../selectors';
import { IState } from '../../store';
import { AsideCountrysideBuilderPromo, IAsideCountrysideBuilderPromoProps } from './AsideCountrysideBuilderPromo';

export function mapStateToProps(state: IState): IAsideCountrysideBuilderPromoProps {
  const villageId = getVillageId(state);

  return {
    offerId: state.offerData.offer.id,
    data: villageId ? getCountrysideBuilderLandingPromoData(state, villageId) : null,
  };
}

export const AsideCountrysideBuilderPromoContainer = connect<IAsideCountrysideBuilderPromoProps>(mapStateToProps)(
  AsideCountrysideBuilderPromo,
);
